import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {Card, CardContent} from "@material-ui/core";
import APPCONFIG from "constants/Config";

export default class EmailTemplates extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Email_Templates._name, 'GET_ADMIN');
		super(props, model);
		this.request = 'GET_ADMIN';

	}


	handlePreview = async (template) => {
		this.setState({ previewLoading: true, previewError: '' });

		let previewModel = new API.BuildClass(Types.Email_Templates._name, 'GET_ADMIN_TEMPLATE_PREVIEW');
		previewModel.filter = {'template': template};
		try {
			let response = await previewModel.submit(this, 'GET_ADMIN_TEMPLATE_PREVIEW');
			this.setState({
				previewHtml: response.preview,
				showPreview: true,
				previewLoading: false,
			});
		} catch (error) {
			this.setState({
				previewError: 'Failed to load email preview',
				previewLoading: false,
			});
		}
	};

	closePreview = () => {
		this.setState({ showPreview: false, previewHtml: '', previewError: '' });
		document.body.style.overflow = 'auto';
	};


	renderPreviewModal = () => {
		const { showPreview, previewHtml, previewError } = this.state;

		if (!showPreview) return null;

		return (
			<div
				className="modal preview-modal"
				tabIndex="-1"
				role="dialog"
				style={{
					display: 'block',
					position: 'fixed',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					background: 'rgba(0, 0, 0, 0.5)',
					zIndex: 1050,
				}}
			>
				<div
					className="modal-dialog modal-lg"
					role="document"
					style={{ maxWidth: '900px', margin: '30px auto' }}
				>
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Email Preview</h5>
							<button type="button" className="close" onClick={this.closePreview}>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div
							className="modal-body"
							style={{
								maxHeight: '70vh',
								overflowY: 'auto',
								padding: '20px',
							}}
						>
							{previewError ? (
								<div className="alert alert-danger" role="alert">
									{previewError}
								</div>
							) : (
								<div
									className="email-preview-content"
									style={{
										maxWidth: '900px',
										margin: '0 auto',
										border: '1px solid #ddd',
										padding: '20px',
										background: '#fff',
									}}
									dangerouslySetInnerHTML={{ __html: previewHtml }}
								/>
							)}
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-secondary"
								onClick={this.closePreview}
							>
								Close
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	};


	render() {
		const { data, pages, limit, loading, previewLoading } = this.state;

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Email Templates')}
								<div className="ml-auto refresh">
									<Button color="secondary" onClick={this.reloadTable}>
										<i className="fa fa-refresh" />
									</Button>
								</div>
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "Template",
									id: "template",
									accessor: (obj) => obj.template,
								},
								{
									Header: "",
									className: "button-cell",
									filterable: false,
									sortable: false,
									width: 300,
									Cell: (props) => (
										<Button
											id={props.original.template}
											color="primary"
											size="sm"
											block={true}
											onClick={() => this.handlePreview(props.original.template)}
											disabled={previewLoading}
										>
											{previewLoading ? 'Loading...' : 'Preview'}
										</Button>
									),
								},
							]}
							manual
							data={data}
							pages={pages}
							loading={loading}
							loadingText="Requesting Data"
							onFetchData={this.fetchData}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined,
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc',
								},
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							className="-striped -highlight"
								/>
								</div>

								<Framework.Elements.LoadingSpinner isLoading={loading || previewLoading} />
						{this.renderPreviewModal()}
				</CardContent>
			</Card>
		);
	}
	}